import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSharedTranslation } from "@/shared/contexts/TranslateContext";

import IconButton from "./IconButton";

import { DATA_ATTR_HIDE_POPUP_ON_CLICK } from "../Popup/popup.constants";

import { settingsActions } from "../../../main/src/redux/settings/actions";
import { selectorSetting } from "../../store/settings/selectors";
import { logOtherEvent, OtherLogEvents } from "../../api/analitics";

const PROPS_CONTROL_BTN_HIDE_POPUP_ON_CLICK = {
  [DATA_ATTR_HIDE_POPUP_ON_CLICK]: true,
};

const IconButtonToggleSetting = ({
  icon,
  disabled,
  setting,
  onContextMenu,
  titleEnable,
  titleDisable,
}) => {
  const { id } = setting;

  const { t } = useSharedTranslation();
  const dispatch = useDispatch();

  const isEnabled = useSelector(selectorSetting(id));

  const title = isEnabled ? titleDisable : titleEnable;

  return (
    <IconButton
      disabled={disabled}
      icon={icon}
      active={isEnabled}
      title={t(title)}
      onContextMenu={onContextMenu}
      onClick={() => {
        const isEnabledNew = !isEnabled;

        logOtherEvent(OtherLogEvents.READER_ACTION, {
          id,
          value: isEnabledNew,
        });

        dispatch(settingsActions.updateSettings(id, isEnabledNew));
      }}
      {...PROPS_CONTROL_BTN_HIDE_POPUP_ON_CLICK}
    />
  );
};

export default IconButtonToggleSetting;
